import React from 'react';
import { useScript } from 'usehooks-ts';
function CoverageMap() {
    useScript(`https://reachmobile.com/map.js`);
    return (
        <div className="o-billboard--coverage o-billboard--split">
            <div className="o-billboard__container o-billboard__container--no-grid">
                <div className="o-billboard__topSplit"></div>
                <div
                    className="o-billboard__frame"
                    dangerouslySetInnerHTML={{
                        __html: `<tmo-web-content-kit
                        kit-type="map" client-id="astoundmobile" variation="roamd-5g">`,
                    }}
                ></div>
            </div>
        </div>
    );
}

export default CoverageMap;
